export default new WeakMap();
